// extracted by mini-css-extract-plugin
export default {"container":"ExpandableParagraph_container__xqZA4","lineClamp":"ExpandableParagraph_lineClamp__3vP6P","button":"ExpandableParagraph_button__cfNUI"};